module.exports = Object.freeze({
  API_URI: process.env.REACT_APP_API_URI,
  // MEDIA_URI: process.env.REACT_APP_MEDIA_URI,
  MEDIA_URI: 'https://cdn.langistan.com/media/',
})
